exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".company-ae {\n  float: left; }\n\n.tableae-pointer {\n  cursor: pointer; }\n\n.table-style tbody tr:hover {\n  background-color: #fbb034 !important;\n  cursor: pointer; }\n\n.add-btn {\n  margin-top: 2rem; }\n\n::ng-deep .dataTables_wrapper .dataTables_scroll div.dataTables_scrollBody > table > tbody > tr > td.dataTables_empty {\n  text-align: center !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/admin/company-ae-table/company-ae-table.component.scss
// module id = ../../../../../src/app/admin/company-ae-table/company-ae-table.component.scss
// module chunks = main